import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { getCurrentLanguage } from "../assets/js/functions";
import "../assets/scss/app.scss";
import "../assets/jquery-pagepiling/jquery.pagepiling.css";

import Home from "../views/Home/Home";
import Exposition from "../views/Exposition/Exposition";
import Map from "../views/Map/Map";

const App = () => {
  return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route exact path={'/exposition'} element={<Exposition />} />
        <Route path="/map" element={<Map />} />
        {/* <Route path="/exposicion1" element={<Expo />} /> */}
      </Routes>
  );
};

export default App;
